/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorServiceAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_SELECT = 'button-select',
  CONTEXTUAL_BAR_PROCEDURE = 'contextual-bar-Procedure',
  FETCH_ORIGIN = 'fetch-origin',
  FETCH_SERVICES = 'fetch-services',
  FIELD_CODE = 'field-code',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_ORIGIN = 'field-origin',
  FILTER_SERVICE = 'filter-service',
  FILTERED_LIST_SERVICES = 'filtered-list-services',
  INPUT_CODE = 'input-code',
  INPUT_DESCRIPTION = 'input-description',
  MAPPER_ORIGIN = 'mapper-origin',
  PAGINATOR = 'paginator',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_PAGINATOR = 'panel-paginator',
  TABLE = 'table',
  TABLE_COLUMN_0 = 'table-column-0',
  TABLE_COLUMN_1 = 'table-column-1',
  TEXT_ORIGIN = 'text-origin',
}
export { LocatorServiceAliases };
